import React from 'react'
import useQuery from '@packages/apollo-hooks/lib/useApolloQuery'
import gql from 'graphql-tag'

export default function useOrderGroup(orderGroupId: string) {
  const {error, orderGroup} = useQuery({
    query: gql`
      query getOrderGroup($orderGroupId: ID) {
        orderGroup(orderGroupId: $orderGroupId) {
          _id
          tableName
          status
        }
      }
    `,
    variables: {orderGroupId},
    pollInterval: 1000 * 10,
    errorPolicy: 'ignore',
    omit: !orderGroupId
  })

  if (!orderGroupId || error) return null

  return orderGroup
}
